import React, {useEffect, useState} from 'react';
import {Box, makeStyles, Tab, Tabs, useTheme} from "@material-ui/core";
import PropTypes from "prop-types";
import {IoIosClose} from "react-icons/io";
import {useSelector} from "react-redux";
import {TextLink, Loader} from "../../../components";
import axios from "axios";
import {adminToken} from "../../../helper";
import styles from "../../../components/Table/styles.module.scss";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

function getModalStyle() {
    const top = 50
    const left = 50

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#6CD7BB"
    }
}))


const initialFilterState = {
    home_id: ""
};

function UpdateHomeIdModel({tableRows, handleCloseUHID, currentSubID, setRefreshPage}) {
    const data = tableRows.filter((item)=>{
            return item?.residence_id == currentSubID
        })
    console.log(JSON.stringify(data));
    const {user} = useSelector(state => ({
            user: state.user
        }));
        
    const [filterState, setFilterState] = useState({home_id:data[0].home_id});

    useEffect(() => {
        
    }, [])

    const [modalStyle] = useState(getModalStyle);
    const [spLoader, setSpLoader] = useState(false);
    
    const classes = useStyles()

    
    const loading = useSelector(state => state.loading);

    return (
        <div style={modalStyle} className={'modal-paper-small update_home_id'}>
            <div className={'modal-top-bar'}>
                <IoIosClose
                    size={20}
                    className={'modal-close'}
                    onClick={handleCloseUHID}
                />
            </div>
            <div className={'modal-header'}>
                <h5>Update Home ID</h5>
            </div>
            <div className={'modal-body'}>
                
                <table width="100%">
                    <tr>
                        <td>Home ID</td>
                        <td>:</td>
                        <td><input type="text" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            } name="home_id" value={filterState?.home_id} autocomplete="off"/></td>
                    </tr>
                </table>
                <button className='btn btn-primary' onClick={(status) => {
                    setSpLoader(true);
                adminToken().then(token =>
                    axios.put(`${AWS_SERVER_APIS}/residences/${currentSubID}`, {
                        home_id: filterState.home_id,
                    }, {headers: {Authorization: `Bearer ${token}`}})
                        .then(res => {
                            if(res.data.type == 'error'){
                                alert('Error: '+res.data.message);
                            }else{
                                alert('Home Id Updated Successfull!');
                                handleCloseUHID();
                                setRefreshPage(Math.floor(100000 + Math.random() * 900000))
                            }
                            // setSpLoader(false);
                        })
                );
                }}>Update</button> {spLoader ? (
                    <div className={styles.loading__container}>
                      <Loader />
                    </div>
                  ) : null}
            </div>
        </div>
    );
}

export default UpdateHomeIdModel;
